import { render, staticRenderFns } from "./_productNearExpiries.vue?vue&type=template&id=036de179&scoped=true&"
import script from "./_productNearExpiries.vue?vue&type=script&lang=js&"
export * from "./_productNearExpiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036de179",
  null
  
)

export default component.exports